import React from 'react'
import { useState,useEffect } from 'react'
import Card from './Card'
export default function Note() {
    const [data,setData] = useState([]);

    async function getData(){
        const res=await fetch("https://crud22.onrender.com/notes")
        const data = await res.json();
        console.log(data)
        setData(data);
    }
    useEffect(() => {
      getData();
    }, [])


    // async function handleDelete(id){
    //     fetch(`https://crud22.onrender.com/notes/${id}`, {
    //     method: "DELETE",
    //     headers: { 'Content-Type': "application/json"}
    // })
    // }
    
  return (
    <div className='Note'>
        {data.map(el=>{
            return(
                <Card data={el} func={getData}/>
            )
        })}
        <Card data={data}/>
    </div>
  )
}
